import { Cell } from 'react-table';
import { FoodItem } from '../types';

const categoriesColumns = [
  {
    id: 'select',
    Header: ({ getToggleAllRowsSelectedProps }: any) => (
      <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
    ),
    Cell: ({ row }: any) => (
      <input
        type="checkbox"
        {...row.getToggleRowSelectedProps()}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
  {
    Header: 'Category Name',
    accessor: 'name',
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Food items',
    accessor: 'foodItems',
    Cell: ({ row }: Cell) =>
      row.values.foodItems.map((item: FoodItem) => item.name).join(', '),
  },
  {
    Header: 'Action',
  },
];

export const marketingCategoriesColumns = [
  {
    Header: 'Category Name',
    accessor: 'name',
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Position',
    accessor: 'position',
  },
  {
    Header: 'Food items',
    accessor: 'foodItems',
    Cell: ({ row }: Cell) =>
      row.values.foodItems.map((item: FoodItem) => item.name).join(', '),
  },
  {
    Header: 'Action',
  },
];

export const categoriesRankColumns = [
  {
    Header: 'Category',
    accessor: 'category',
    Cell: ({ row }: Cell) => row.values.category?.name,
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Position',
    accessor: 'position',
  },
  {
    Header: 'Food items',
    accessor: 'foodItems',
    Cell: ({ row }: Cell) =>
      row.values.category?.foodItems
        ?.map((item: FoodItem) => item.name)
        .join(', '),
  },
  {
    Header: 'Action',
  },
];

export { categoriesColumns };
